// extracted by mini-css-extract-plugin
export var container = "start-project-module--container--12LZN";
export var form = "start-project-module--form--3-5Ws";
export var radioGroup = "start-project-module--radioGroup--3uwBo";
export var thankYou = "start-project-module--thankYou--xjvjA";